/*
 * paramètres de fancybox
 */
$.fancybox.defaults.afterShow = function(instance) {

	if( instance.current.type == 'ajax' ) {

		// on initialise les selectboxes
		$('.selectpicker', instance.current.$content).selectpicker();

		// on initialise les champs date
		$('[data-toggle="datepicker"]', instance.current.$content).datepicker({
			language: 'fr-FR',
			autoHide: true,
			zIndex: 99999
		});

		// on trigger un custom event
		instance.current.$content.trigger('lightbox:show');

		// on init les popover
		$('[data-toggle="popover"]', instance.current.$content).popover();

	}

};